import { Loading } from 'element-ui'

export default {
  actions: {
    startLoading: function() {
      return Loading.service({
        fullscreen: true, 
        lock: true, 
        spinner: 'span', 
        background: 'white',
        customClass: 'menu-loading',
      })
    },
    endLoading: function() {
      return Loading.service({ 
        fullscreen: true,
        lock: true,
        spinner: 'span', 
        background: 'transparent',
      }).close()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/loading/index.js